module.exports = __webpack_public_path__ + "img/dep_snacks.ff584f3e.png";